import { useSyncExternalStore } from 'react'

const DESKTOP_VIEWPORT_QUERY = '(min-width: 769px)'

const subscribe = (onStoreChange: () => void) => {
  const mediaQueryList = globalThis.matchMedia(DESKTOP_VIEWPORT_QUERY)
  mediaQueryList.addEventListener('change', onStoreChange)
  return () => {
    mediaQueryList.removeEventListener('change', onStoreChange)
  }
}

const getSnapshot = () => {
  return globalThis.matchMedia(DESKTOP_VIEWPORT_QUERY).matches
}

export const useIsDesktopViewport = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
